import React from 'react';
import { useSWRConfig } from 'swr';

// Cache Key Generator
export const segmentResultCacheKeyGenerator = {
  generateByBroadCastIdKey: ({
    broadCastId,
    merchantId,
  }: {
    broadCastId: string;
    merchantId: string;
  }) => {
    return ['SEGMENT_RESULT', 'BY_BROADCAST_ID', broadCastId, merchantId] as const;
  },
};

// Cache Mutator
export const useSegmentResultCacheMutator = () => {
  const { mutate } = useSWRConfig();

  return React.useMemo(
    () => ({
      mutateByBroadCastId: ({ broadCastId, merchantId }: { broadCastId: string; merchantId: string }) =>
        mutate(
          segmentResultCacheKeyGenerator.generateByBroadCastIdKey({ broadCastId, merchantId })
        ),
    }),
    [mutate]
  );
};